const inMemoryStorage: { [key: string]: any } = {};

const isLocalStorageAvailable = () => {
  const testKey = "_storageTest_";
  try {
    if (typeof window === "undefined" || !window.localStorage) {
      console.warn(
        "localStorage is not available: window or localStorage is undefined."
      );
      return false;
    }
    // Attempt to use localStorage to see
    // this validates if localStorage is functional
    window.localStorage.setItem(testKey, testKey);
    window.localStorage.removeItem(testKey);
    return true;
  } catch (error) {
    console.warn(`localStorage is not available: ${error}`);
    return false;
  }
};

export const getFromLocalStorage = <T>(key: string): T | null => {
  if (isLocalStorageAvailable()) {
    try {
      const value = localStorage.getItem(key);
      return value ? (JSON.parse(value) as T) : null;
    } catch (error) {
      console.error(`Error getting item from localStorage: ${error}`);
      return null;
    }
  } else {
    return inMemoryStorage[key] || null;
  }
};

export const setInLocalStorage = <T>(key: string, value: T): void => {
  if (isLocalStorageAvailable()) {
    try {
      localStorage.setItem(key, JSON.stringify(value));
    } catch (error) {
      console.error(`Error setting item in localStorage: ${error}`);
    }
  } else {
    inMemoryStorage[key] = value;
  }
};
